var map = {
	"./bg-dotted-line.svg": 108,
	"./bg-our-philosophy.svg": 937,
	"./bg-our-team.svg": 301,
	"./bg-welcome.svg": 58,
	"./carousel-1.webp": 820,
	"./carousel-2.webp": 514,
	"./carousel-3.webp": 141,
	"./carousel-4.webp": 281,
	"./contact.webp": 106,
	"./hexagon.svg": 736,
	"./image-1.webp": 839,
	"./image-2.webp": 387,
	"./image-3.webp": 588,
	"./logo.webp": 879,
	"./photo-medina.webp": 570,
	"./photo-mersida.webp": 42,
	"./photo-michele.webp": 478,
	"./photo-nadia.webp": 279
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;